// extracted by css-extract-rspack-plugin
export default {"cls1":"PaperClaimedToast-cls1_epZ","cls2":"PaperClaimedToast-cls2_MZH PaperClaimedToast-cls1_epZ"};